import { MENU_CONFIG, HOSTS } from "@dod/consts";

export const filterMenuConfigByPermissions = async (userId) => {
   if (!userId) return [];
   const env = window.location.href.includes("test") ? "test" : "prod";
   const userPermissions = await fetch(
      HOSTS[env] + `/uprawnienia/api/user-apps-persmissions/${userId}`
   )
      .then((resp) => resp.json())
      .catch((_error) => {
         // TODO: Handle errors
         return [];
      });
   const filterChildren = (children) => {
      if (!children) return children;
      return children
         .filter((childItem) => {
            if (childItem.appId === undefined) return true;
            if (userPermissions.apps.some((app) => app.appId === childItem.appId)) {
               const permissionIds = userPermissions.apps.find(
                  (app) => app.appId === childItem.appId
               )?.permissionIds;
               if (!permissionIds || permissionIds.length === 0 || !childItem.permissionId)
                  return false;
               if (Array.isArray(childItem.permissionId))
                  return childItem.permissionId?.some((p) => permissionIds.includes(p));
               else return permissionIds.includes(childItem.permissionId);
            }
         })
         .map((childItem) => ({
            ...childItem,
            children: filterChildren(childItem.children)
         }));
   };

   return [...MENU_CONFIG]
      .filter((menuItem) => {
         if (
            menuItem.appId === undefined ||
            userPermissions.apps.some((app) => app.appId === menuItem.appId)
         )
            return true;
         return false;
      })
      .map((menuItem) => {
         return {
            ...menuItem,
            children: filterChildren(menuItem.children)
         };
      });
};
